import { render } from "./PatientIndex.vue?vue&type=template&id=006b7a97&scoped=true"
import script from "./PatientIndex.vue?vue&type=script&lang=ts"
export * from "./PatientIndex.vue?vue&type=script&lang=ts"

import "./PatientIndex.vue?vue&type=style&index=0&id=006b7a97&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-006b7a97"

export default script